import {useMutation} from '@apollo/client';
import {UPDATE_PRODUCT} from "../productTypeDefs";

export const useMutationUpdateProduct = (options?: any): any => (
  useMutation(UPDATE_PRODUCT, options)
);
